<!--
  --
  -- 生年月日入力 コンポーネント
  --
  -->
<template>
  <c-date-field
    label="生年月日"
    v-model="form.birthday"
    :min-year="minYear"
    :max-year="maxYear"
    :rules="[rule.required('生年月日'), rule.date, rule.birthday]"
  />
</template>

<script>
import CDateField from '@/components/CDateField'

import * as C from '@/consts'

export default {
  name: 'CProfileBirthday',
  components: {
    CDateField
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    minYear: 0,
    maxYear: 0
  }),
  created () {
    const thisYear = new Date().getFullYear()
    this.minYear = thisYear - C.AGE_MAX // 入力できる最小の年 = 最高齢の誕生年
    this.maxYear = thisYear - C.AGE_MIN // 入力できる最大の年 = 最年少の誕生年
  }
}
</script>
